require('./karstdev.css');
require('@fontsource/montserrat/300.css');
require('@fontsource/montserrat/400.css');
require('@fontsource/montserrat/500.css');
require('@fontsource/montserrat/700.css');
